import useUser from '@ubeya/shared/hooks/auth/useUser';

// Kept in sync with INVOICING_ALLOWED_EMAILS in giovanni's apps/smart/src/constants/invoicing.ts,
// which is what actually enforces this — hiding the page here just stops it being offered.
export const INVOICING_ALLOWED_EMAILS = ['wisama@ubeya.com', 'yuval@ubeya.com', 'omri@ubeya.com', 'matana@ubeya.com'];

const useCanAccessInvoicing = () => {
  const { data } = useUser();

  return INVOICING_ALLOWED_EMAILS.includes((data?.email || '').toLowerCase());
};

export default useCanAccessInvoicing;
